module.exports = __webpack_public_path__ + "img/gold-trophy.db83215d.png";